// extracted by mini-css-extract-plugin
export default {"buttonsGroup":"buttonsGroup_buttonsGroup__Le0mp","fixed":"buttonsGroup_fixed__N6DgA","fullWidth":"buttonsGroup_fullWidth__p1Z3b","buttonWrapper":"buttonsGroup_buttonWrapper__tkRWW"};